/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { NbToastrService, NbGlobalLogicalPosition, NbIconConfig } from '@nebular/theme';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
    selector: 'ngx-app',
    template: '<router-outlet></router-outlet>',
    styles: [`
    @media only screen and (max-width: 426px) {
        ::ng-deep .cdk-overlay-pane {overflow: scroll;}
    }

    @media only screen and (min-width: 426px) {
        ::ng-deep .cdk-overlay-pane {overflow: inherit;}
    }
    `],
})
export class AppComponent implements OnInit {

    constructor(
        private analytics: AnalyticsService,
        private seoService: SeoService,
        private afMessaging: AngularFireMessaging,
        private toastrService: NbToastrService,
        private titleService: Title,
    ) { }

    ngOnInit(): void {
        // TODO activate the analytics and performance services
        this.analytics.trackPageViews();
        this.seoService.trackCanonicalChanges();

        // Foreground Notifications
        const iconConfig: NbIconConfig = { icon: 'alert-triangle', pack: 'eva' };

        this.afMessaging.messages.subscribe((payload: any) => {
            // console.log(payload);
            this.toastrService.show(payload.notification.body, payload.notification.title, {
                status: 'danger',
                duration: 7000,
                destroyByClick: false,
                position: NbGlobalLogicalPosition.TOP_START,
                icon: iconConfig,
            });
        });

        // Set Title
        this.setDocTitle();
    }

    setDocTitle() {
        if (environment.type === 'dev') this.titleService.setTitle('DEV | ' + this.titleService.getTitle());
        if (environment.type === 'local') this.titleService.setTitle('LOCAL | ' + this.titleService.getTitle());
    }
}
